import React from 'react'
import {Box, Typography} from '@mui/material'
import ReactHtmlParser from 'react-html-parser'
import AppDialog from 'src/components-new/feedback/AppDialog'
import {PerformanceItem} from 'src/pages-new/homepage/types'
import {formatItemDate, getPerformanceStatusIcon} from 'src/pages-new/homepage/utils'

interface PerformanceDetailDialogProps {
  open: boolean
  onClose: () => void
  performance: PerformanceItem | null
}

const ROW_LABEL_SX = {fontSize: 12, color: 'text.secondary', mb: 0.25}
const ROW_VALUE_SX = {fontSize: 14, fontWeight: 500}

export default function PerformanceDetailDialog({open, onClose, performance}: PerformanceDetailDialogProps) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title='Dettaglio prestazione'
      maxWidth='xs'
    >
      {performance && (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, pt: 1}}>
          <Box sx={{width: '100%', display: 'flex', flexDirection: 'column', gap: 1.5}}>
            <Box>
              <Typography sx={ROW_LABEL_SX}>Data</Typography>
              <Typography sx={ROW_VALUE_SX}>{formatItemDate(performance.date) || '—'}</Typography>
            </Box>
            <Box>
              <Typography sx={ROW_LABEL_SX}>Stato</Typography>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
                {getPerformanceStatusIcon(performance.state)}
                <Typography sx={ROW_VALUE_SX}>{performance.state || '—'}</Typography>
              </Box>
            </Box>
            {performance.location && (
              <Box>
                <Typography sx={ROW_LABEL_SX}>Sede</Typography>
                <Typography sx={ROW_VALUE_SX}>{performance.location}</Typography>
              </Box>
            )}
            {performance.notes && (
              <Box sx={{fontSize: 14, lineHeight: 1.6}}>
                {ReactHtmlParser(performance.notes)}
              </Box>
            )}
          </Box>
        </Box>
      )}
    </AppDialog>
  )
}
